<template>
  <div class="expert-info-maintenance">
    <!-- 页面标题 -->
    <div class="page-header">
      <div class="header-left">
        <h2>代理专家库</h2>
      </div>
    </div>
    <!-- 搜索筛选区域 -->
    <div class="search-section">
      <div class="search-filters">
        <el-input v-model="searchForm.expertName" placeholder="专家姓名" style="width: 200px; margin-right: 10px;">
        </el-input>
        <el-cascader ref="searchIndustryCascader" v-model="searchForm.industry" :props="industryCascaderProps"
          placeholder="选择评标专业" clearable style="width: 200px; margin-right: 10px;"
          @change="handleSearchIndustryChange"></el-cascader>
        <el-cascader ref="searchRegionCascader" v-model="searchForm.region" :props="regionCascaderProps"
          placeholder="选择地区" clearable style="width: 200px; margin-right: 10px;"
          @change="handleSearchRegionChange"></el-cascader>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
        <el-button type="success" icon="el-icon-plus" @click="showAddDialog">添加</el-button>
      </div>
    </div>
    <!-- 数据表格 -->
    <div class="table-section">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="expertName" label="专家姓名"></el-table-column>
        <el-table-column label="性别" width="80">
          <template slot-scope="scope">
            {{ scope.row.sex === 1 ? '男' : scope.row.sex === 2 ? '女' : '' }}
          </template>
        </el-table-column>
        <el-table-column label="地区">
          <template slot-scope="scope">
            {{ [scope.row.provinceName, scope.row.cityName, scope.row.areaName].filter(Boolean).join('/') }}
          </template>
        </el-table-column>
        <el-table-column prop="workUnit" label="工作单位"></el-table-column>
        <el-table-column prop="mobile" label="手机号"></el-table-column>
        <el-table-column prop="idNo" label="身份证号"></el-table-column>
        <el-table-column prop="industryName" label="评标专业"></el-table-column>
        <el-table-column label="抽取状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.extractState === 1 ? 'success' : 'danger'">
              {{ scope.row.extractState === 1 ? '正常' : '暂停' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="锁定状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.lockState === 0 ? 'success' : 'danger'">
              {{ scope.row.lockState === 0 ? '正常' : '锁定' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="showEditDialog(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
            <el-button type="text" size="small" :class="scope.row.extractState === 1 ? 'pause-btn' : 'enable-btn'"
              @click="handleToggleStatus(scope.row)">
              {{ scope.row.extractState === 1 ? '暂停' : '开启' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pagination-section">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <!-- 添加专家弹窗 -->
    <el-dialog title="添加专家信息" :visible.sync="addDialogVisible" width="800px" :close-on-click-modal="false"
      :append-to-body="true" class="expert-add-dialog">
      <el-form ref="addForm" :model="addForm" :rules="formRules" label-width="120px" class="expert-form">
        <el-form-item label="专家姓名" prop="expertName" required>
          <el-input v-model="addForm.expertName" placeholder="请输入专家姓名"></el-input>
        </el-form-item>

        <el-form-item label="性别" prop="sex" required>
          <el-radio-group v-model="addForm.sex">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="地区" prop="region" required>
          <el-cascader ref="addRegionCascader" v-model="addForm.region" :props="regionCascaderProps" placeholder="请选择地区"
            style="width: 100%;" @change="handleAddRegionChange"></el-cascader>
        </el-form-item>

        <el-form-item label="工作单位" prop="workUnit" required>
          <el-input v-model="addForm.workUnit" placeholder="请输入工作单位"></el-input>
        </el-form-item>

        <el-form-item label="手机号" prop="mobile" required>
          <el-input v-model="addForm.mobile" placeholder="请输入手机号"></el-input>
        </el-form-item>

        <el-form-item label="身份证号" prop="idNo">
          <el-input v-model="addForm.idNo" placeholder="请输入身份证号"></el-input>
        </el-form-item>

        <el-form-item label="评标专业" prop="industry" required>
          <el-cascader ref="addIndustryCascader" v-model="addForm.industry" :props="industryCascaderProps"
            placeholder="请选择评标专业" style="width: 100%;" @change="handleAddIndustryChange"></el-cascader>
        </el-form-item>

        <el-form-item label="职称" prop="professionalTitle" required>
          <el-input v-model="addForm.professionalTitle" placeholder="请输入职称"></el-input>
        </el-form-item>

        <!-- <el-form-item label="所学专业" >
          <el-input v-model="addForm.major" placeholder="请输入所学专业"></el-input>
        </el-form-item>

        <el-form-item label="从事专业" >
          <el-input v-model="addForm.doMajor" placeholder="请输入从事专业"></el-input>
        </el-form-item> -->
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelAdd">取消</el-button>
        <el-button type="primary" @click="confirmAdd">确定</el-button>
      </div>
    </el-dialog>

    <!-- 编辑专家弹窗 -->
    <el-dialog title="编辑专家信息" :visible.sync="editDialogVisible" width="800px" :close-on-click-modal="false"
      :append-to-body="true" class="expert-edit-dialog">
      <el-form ref="editForm" :model="editForm" :rules="formRules" label-width="120px" class="expert-form">
        <el-form-item label="专家姓名" prop="expertName" required>
          <el-input v-model="editForm.expertName" placeholder="请输入专家姓名"></el-input>
        </el-form-item>

        <el-form-item label="性别" prop="sex" required>
          <el-radio-group v-model="editForm.sex">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="地区" prop="region" required>
          <el-cascader ref="editRegionCascader" v-model="editForm.region" :props="regionCascaderProps"
            placeholder="请选择地区" style="width: 100%;" @change="handleEditRegionChange"></el-cascader>
        </el-form-item>

        <el-form-item label="工作单位" prop="workUnit" required>
          <el-input v-model="editForm.workUnit" placeholder="请输入工作单位"></el-input>
        </el-form-item>

        <el-form-item label="手机号" prop="mobile" required>
          <el-input v-model="editForm.mobile" placeholder="请输入手机号"></el-input>
        </el-form-item>

        <el-form-item label="身份证号" prop="idNo">
          <el-input v-model="editForm.idNo" placeholder="请输入身份证号"></el-input>
        </el-form-item>

        <el-form-item label="评标专业" prop="industry" required>
          <el-cascader ref="editIndustryCascader" v-model="editForm.industry" :props="industryCascaderProps"
            placeholder="请选择评标专业" style="width: 100%;" @change="handleEditIndustryChange"></el-cascader>
        </el-form-item>

        <el-form-item label="职称" prop="professionalTitle" required>
          <el-input v-model="editForm.professionalTitle" placeholder="请输入职称"></el-input>
        </el-form-item>

        <!-- <el-form-item label="所学专业" prop="major" required>
          <el-input v-model="editForm.major" placeholder="请输入所学专业"></el-input>
        </el-form-item>

        <el-form-item label="从事专业" prop="doMajor" required>
          <el-input v-model="editForm.doMajor" placeholder="请输入从事专业"></el-input>
        </el-form-item> -->
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelEdit">取消</el-button>
        <el-button type="primary" @click="confirmEdit">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { getExpertList, saveExpert, deleteExpert, enableExpert } from '@/api/modules/agent'
import RegionUtils from '@/utils/regionUtils'

export default {
  name: 'ExpertInfoMaintenance',

  data() {
    return {
      searchForm: {
        expertName: '',
        industry: [],
        industryCode: '',
        industryName: '',
        region: [],
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        areaCode: '',
        areaName: ''
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      // 添加专家弹窗相关数据
      addDialogVisible: false,
      addForm: {
        id: '',
        expertName: '',
        sex: '',
        region: [],
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        areaCode: '',
        areaName: '',
        workUnit: '',
        mobile: '',
        idNo: '',
        industry: [],
        industryCode: '',
        industryName: '',
        professionalTitle: '',
        major: '',
        doMajor: ''
      },
      // 级联选择器配置
      regionCascaderProps: RegionUtils.getCascaderProps('REGION_CODE'),
      industryCascaderProps: RegionUtils.getCascaderProps('EXPERT_INDUSTRY_CODE'),
      // 编辑专家弹窗相关数据
      editDialogVisible: false,
      editForm: {
        id: '',
        expertName: '',
        sex: '',
        region: [],
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        areaCode: '',
        areaName: '',
        workUnit: '',
        mobile: '',
        idNo: '',
        industry: [],
        industryCode: '',
        industryName: '',
        professionalTitle: '',
        major: '',
        doMajor: ''
      },
      currentEditIndex: -1,
      formRules: {
        expertName: [
          { required: true, message: '请输入专家姓名' }
        ],
        sex: [
          { required: true, message: '请选择性别' }
        ],
        region: [
          { required: true, message: '请选择地区'}
        ],
        workUnit: [
          { required: true, message: '请输入工作单位' }
        ],
        mobile: [
          { required: true, message: '请输入手机号' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' }
        ],
        industry: [
          { required: true, message: '请选择评标专业' }
        ],
        professionalTitle: [
          { required: true, message: '请输入职称' }
        ],
      }
    }
  },
  computed: {
    channelCode() {
      return this.$channelMaterial.getChannelCode()
    },
  },
  mounted() {
    // 页面初始化
    this.initPage()
  },
  methods: {
    // 页面初始化
    initPage() {
      this.getExpertList()

    },
    // 获取专家列表
    getExpertList() {
      const params = {
        channelCode:this.channelCode,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        expertName: this.searchForm.expertName || undefined,
        industryCode: this.searchForm.industryCode || undefined,
        provinceCode: this.searchForm.provinceCode || undefined,
        cityCode: this.searchForm.cityCode || undefined,
        areaCode: this.searchForm.areaCode || undefined
      };
      getExpertList(params).then(res => {
        if (res.code === 200 && res.data) {
          this.tableData = res.data.records || [];
          this.total = res.data.total || 0;
        }
      }).catch(err => {
        this.$message.error('获取专家列表失败');
      });
    },
    // 搜索表单-评标专业级联选择器变化
    handleSearchIndustryChange(value) {
      RegionUtils.handleRegionChange(
        value,
        this.$refs.searchIndustryCascader,
        this.searchForm,
        {
          provinceField: '',
          provinceCodeField: '',
          cityField: '',
          cityCodeField: '',
          countyField: 'industryName',
          countyCodeField: 'industryCode',
          regionField: 'industry'
        },
        this,
        'BID_SECTION_CLASSIFY_CODE'
      );
    },
    // 搜索表单-地区级联选择器变化
    handleSearchRegionChange(value) {
      RegionUtils.handleRegionChange(
        value,
        this.$refs.searchRegionCascader,
        this.searchForm,
        {
          provinceField: 'provinceName',
          provinceCodeField: 'provinceCode',
          cityField: 'cityName',
          cityCodeField: 'cityCode',
          countyField: 'areaName',
          countyCodeField: 'areaCode',
          regionField: 'region'
        },
        this,
        'REGION_CODE'
      );
    },

    // 分页大小改变
    handleSizeChange(val) {
      this.pageSize = val;
      this.getExpertList();
    },
    // 当前页改变
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getExpertList();
    },
    normalizeExpertForm(form) {
      const fields = ['expertName', 'workUnit', 'mobile', 'idNo', 'professionalTitle', 'major', 'doMajor'];
      fields.forEach(field => {
        if (typeof form[field] === 'string') {
          form[field] = form[field].trim();
        }
      });
    },
    // 添加专家相关方法
    showAddDialog() {
      this.addDialogVisible = true;
      this.resetAddForm();
    },
    // 重置添加表单
    resetAddForm() {
      this.addForm = {
        id: '',
        expertName: '',
        sex: '',
        region: [],
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        areaCode: '',
        areaName: '',
        workUnit: '',
        mobile: '',
        idNo: '',
        industry: [],
        industryCode: '',
        industryName: '',
        professionalTitle: '',
        major: '',
        doMajor: ''
      };
      // 清除表单验证
      if (this.$refs.addForm) {
        this.$refs.addForm.clearValidate();
      }
    },
    // 取消添加
    cancelAdd() {
      this.addDialogVisible = false;
      this.resetAddForm();
    },
    // 确认添加
    confirmAdd() {
      this.normalizeExpertForm(this.addForm);
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          // 构建接口参数
          const params = {
            id: this.addForm.id,
            expertName: this.addForm.expertName,
            sex: this.addForm.sex,
            provinceCode: this.addForm.provinceCode,
            provinceName: this.addForm.provinceName,
            cityCode: this.addForm.cityCode,
            cityName: this.addForm.cityName,
            areaCode: this.addForm.areaCode,
            areaName: this.addForm.areaName,
            workUnit: this.addForm.workUnit,
            mobile: this.addForm.mobile,
            idNo: this.addForm.idNo,
            industryCode: this.addForm.industryCode,
            industryName: this.addForm.industryName,
            professionalTitle: this.addForm.professionalTitle,
            major: this.addForm.major,
            doMajor: this.addForm.doMajor,
                channelCode:this.channelCode,
          };

          // 调用保存接口
          saveExpert(params).then(res => {
            if (res.code === 200) {
              this.$message.success('专家信息添加成功！');
              this.addDialogVisible = false;
              this.resetAddForm();
              this.getExpertList();
            } else {
              this.$message.error(res.msg || '添加失败');
            }
          }).catch(err => {
            this.$message.error('添加失败，请稍后重试');
          });
        } else {
          this.$message.error('请完善必填信息！');
          return false;
        }
      });
    },
    // 添加表单-地区级联选择器变化
    handleAddRegionChange(value) {
      RegionUtils.handleRegionChange(
        value,
        this.$refs.addRegionCascader,
        this.addForm,
        {
          provinceField: 'provinceName',
          provinceCodeField: 'provinceCode',
          cityField: 'cityName',
          cityCodeField: 'cityCode',
          countyField: 'areaName',
          countyCodeField: 'areaCode',
          regionField: 'region'
        },
        this,
        'REGION_CODE'
      );
    },
    // 添加表单-评标专业级联选择器变化
    handleAddIndustryChange(value) {
      RegionUtils.handleRegionChange(
        value,
        this.$refs.addIndustryCascader,
        this.addForm,
        {
          provinceField: '',
          provinceCodeField: '',
          cityField: '',
          cityCodeField: '',
          countyField: 'industryName',
          countyCodeField: 'industryCode',
          regionField: 'industry'
        },
        this,
        'BID_SECTION_CLASSIFY_CODE'
      );
    },
    // 编辑专家相关方法
    showEditDialog(row) {
      this.currentEditIndex = this.tableData.findIndex(item => item === row);
      this.editDialogVisible = true;
      this.fillEditForm(row);
    },
    fillEditForm(row) {
      // 构建地区级联选择器的值（编码数组）
      const regionValue = [];
      if (row.provinceCode) regionValue.push(row.provinceCode);
      if (row.cityCode) regionValue.push(row.cityCode);
      if (row.areaCode) regionValue.push(row.areaCode);

      // 构建评标专业级联选择器的值（编码数组）
      // 例如：industryCode 为 "A0101" 时，倒推为 ["A", "A01", "A0101"]
      const industryValue = this.buildIndustryCascaderValue(row.industryCode);

      // 填充编辑表单数据
      this.editForm = {
        id: row.id || '',
        expertName: row.expertName || row.name || '',
        sex: row.sex || (row.gender === '男' ? 1 : row.gender === '女' ? 2 : ''),
        region: regionValue,
        provinceCode: row.provinceCode || '',
        provinceName: row.provinceName || '',
        cityCode: row.cityCode || '',
        cityName: row.cityName || '',
        areaCode: row.areaCode || '',
        areaName: row.areaName || '',
        workUnit: row.workUnit || '',
        mobile: row.mobile || '',
        idNo: row.idNo || row.idCard || '',
        industry: industryValue,
        industryCode: row.industryCode || '',
        industryName: row.industryName || '',
        professionalTitle: row.professionalTitle || '',
        major: row.major || '',
        doMajor: row.doMajor || ''
      };

      // 清除表单验证
      if (this.$refs.editForm) {
        this.$refs.editForm.clearValidate();
      }
    },
    // 根据 industryCode 倒推级联选择器的值
    // 例如：industryCode 为 "A0101" 时，返回 ["A", "A01", "A0101"]
    buildIndustryCascaderValue(industryCode) {
      if (!industryCode) return [];

      const result = [];
      const code = industryCode.toString();

      // 第一级：取第一个字符（如 "A"）
      if (code.length >= 1) {
        result.push(code.substring(0, 1));
      }

      // 第二级：取前三个字符（如 "A01"）
      if (code.length >= 3) {
        result.push(code.substring(0, 3));
      }

      // 第三级：完整编码（如 "A0101"）
      if (code.length >= 4) {
        result.push(code);
      }

      return result;
    },
    // 取消编辑
    cancelEdit() {
      this.editDialogVisible = false;
      this.resetEditForm();
    },
    // 重置编辑表单
    resetEditForm() {
      this.editForm = {
        id: '',
        expertName: '',
        sex: '',
        region: [],
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        areaCode: '',
        areaName: '',
        workUnit: '',
        mobile: '',
        idNo: '',
        industry: [],
        industryCode: '',
        industryName: '',
        professionalTitle: '',
        major: '',
        doMajor: ''
      };
      this.currentEditIndex = -1;
      // 清除表单验证
      if (this.$refs.editForm) {
        this.$refs.editForm.clearValidate();
      }
    },
    // 确认编辑
    confirmEdit() {
      this.normalizeExpertForm(this.editForm);
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          // 构建接口参数
          const params = {
            id: this.editForm.id,
            expertName: this.editForm.expertName,
            sex: this.editForm.sex,
            provinceCode: this.editForm.provinceCode,
            provinceName: this.editForm.provinceName,
            cityCode: this.editForm.cityCode,
            cityName: this.editForm.cityName,
            areaCode: this.editForm.areaCode,
            areaName: this.editForm.areaName,
            workUnit: this.editForm.workUnit,
            mobile: this.editForm.mobile,
            idNo: this.editForm.idNo,
            industryCode: this.editForm.industryCode,
            industryName: this.editForm.industryName,
            professionalTitle: this.editForm.professionalTitle,
            major: this.editForm.major,
            doMajor: this.editForm.doMajor,
                channelCode:this.channelCode,
          };

          // 调用保存接口
          saveExpert(params).then(res => {
            if (res.code === 200) {
              this.$message.success('专家信息修改成功！');
              this.editDialogVisible = false;
              this.resetEditForm();
              this.getExpertList();
            } else {
              this.$message.error(res.msg || '修改失败');
            }
          }).catch(err => {
            this.$message.error('修改失败，请稍后重试');
          });
        } else {
          this.$message.error('请完善必填信息！');
          return false;
        }
      });
    },
    // 编辑表单-地区级联选择器变化
    handleEditRegionChange(value) {
      RegionUtils.handleRegionChange(
        value,
        this.$refs.editRegionCascader,
        this.editForm,
        {
          provinceField: 'provinceName',
          provinceCodeField: 'provinceCode',
          cityField: 'cityName',
          cityCodeField: 'cityCode',
          countyField: 'areaName',
          countyCodeField: 'areaCode',
          regionField: 'region'
        },
        this,
        'REGION_CODE'
      );
    },
    // 编辑表单-评标专业级联选择器变化
    handleEditIndustryChange(value) {
      RegionUtils.handleRegionChange(
        value,
        this.$refs.editIndustryCascader,
        this.editForm,
        {
          provinceField: '',
          provinceCodeField: '',
          cityField: '',
          cityCodeField: '',
          countyField: 'industryName',
          countyCodeField: 'industryCode',
          regionField: 'industry'
        },
        this,
        'BID_SECTION_CLASSIFY_CODE'
      );
    },
    // 搜索功能
    handleSearch() {
      this.currentPage = 1;
      this.getExpertList();
    },
    // 重置搜索条件
    handleReset() {
      this.searchForm = {
        expertName: '',
        industry: [],
        industryCode: '',
        industryName: '',
        region: [],
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        areaCode: '',
        areaName: ''
      };
      this.currentPage = 1;
      this.getExpertList();
    },
    // 删除专家
    handleDelete(row) {
      this.$confirm(`确定要删除专家 "${row.expertName}" 吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteExpert(row.id).then(res => {
          if (res.code === 200) {
            this.$message.success('删除成功');
            this.getExpertList();
          }
        });
      }).catch(() => { });
    },
    // 切换专家状态
    handleToggleStatus(row) {
      const action = row.extractState === 1 ? '暂停' : '开启';
      this.$confirm(`确定要${action}专家 "${row.expertName}" 吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        enableExpert(row.id).then(res => {
          if (res.code === 200) {
            this.$message.success('操作成功');
            this.getExpertList();
          }
        });
      }).catch(() => { });
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.expert-info-maintenance {
  .apply-minimal-gray-theme();
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;

  .header-left {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }

  h2 {
    font-size: 20px;
    font-weight: 600;
    color: @gray-700;
    margin: 0;
    line-height: 1.5;
    position: relative;
    padding-left: 10px;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 16px;
      background: @primary-color;
      border-radius: 2px;
    }
  }
}

.header-info {
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  padding: 0 12px;
  font-size: 13px;
  color: @gray-600;
  background: @gray-100;
  border: 1px solid @gray-200;
  border-radius: 4px;
}

.search-section {
  background: #fff;
  padding: 16px 20px;
  border-radius: 4px;
  box-shadow: @shadow-sm;
  margin-bottom: 16px;
  text-align: start;
}

.search-filters {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 0;

  /deep/ .el-input__inner,
  /deep/ .el-cascader .el-input__inner {
    border-color: @gray-300;
    color: @gray-700;

    &:focus {
      border-color: @primary-color;
    }

    &::placeholder {
      color: @gray-400;
    }
  }

  /deep/ .el-button {
    transition: all @transition-base ease;

    &:hover {
      transform: translateY(-1px);
    }
  }

  /deep/ .el-button--success {
    background-color: @primary-color;
    border-color: @primary-color;

    &:hover,
    &:focus {
      background-color: @primary-hover;
      border-color: @primary-hover;
    }
  }
}

.table-section {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  box-shadow: @shadow-sm;
  margin-bottom: 16px;

  /deep/ .el-table {
    th {
      background: @gray-50 !important;
      color: @gray-700 !important;
      font-weight: 600 !important;
      border-color: @gray-200 !important;
    }

    td {
      color: @gray-600;
      border-color: @gray-200 !important;
    }

    .el-table__row:hover {
      background-color: @gray-50;
    }

    .el-button--text {
      color: @gray-600;

      &:hover {
        color: @primary-color;
      }
    }
  }
}

.pagination-section {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background: #fff;
  padding: 16px 20px;
  border-radius: 4px;
  box-shadow: @shadow-sm;
}

.pause-btn {
  color: @error-color !important;
}

.enable-btn {
  color: @success-color !important;
}

.expert-form {
  /deep/ .el-form-item__label {
    color: @gray-700;
    font-weight: 500;
  }

  /deep/ .el-input__inner,
  /deep/ .el-textarea__inner,
  /deep/ .el-cascader .el-input__inner {
    border-color: @gray-300;
    color: @gray-700;

    &:focus {
      border-color: @primary-color;
    }

    &::placeholder {
      color: @gray-400;
    }
  }

  /deep/ .el-radio__label {
    color: @gray-600;
  }

  /deep/ .el-radio__input.is-checked .el-radio__inner {
    border-color: @primary-color;
    background: @primary-color;
  }

  /deep/ .el-radio__input.is-checked+.el-radio__label {
    color: @primary-color;
  }
}

.dialog-footer {
  /deep/ .el-button--primary {
    background-color: @primary-color;
    border-color: @primary-color;

    &:hover,
    &:focus {
      background-color: @primary-hover;
      border-color: @primary-hover;
    }
  }
}

/deep/ .el-tag--success {
  background: fade(@success-color, 10%);
  color: @success-color;
  border-color: fade(@success-color, 20%);
}

/deep/ .el-tag--danger {
  background: fade(@error-color, 10%);
  color: @error-color;
  border-color: fade(@error-color, 20%);
}

/deep/ .el-dialog__header {
  background: @gray-50;
  border-bottom: 1px solid @gray-200;
}

/deep/ .el-dialog__title {
  color: @gray-700;
  font-weight: 600;
}
</style>
